import Vue from 'vue';
import 'src/material/global/vendor/chart-js/Chart.min';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import analyticsService from '../../../services/analytics';
import mixin from './../../../mixins/mixin';
import accountService from '../../../services/account';
import rentalService from '../../../services/rental';

export default {
  data() {
    return {
      selectedRental: null,
      enviromentData: [],
      rentals: [],
      year: '',
      month: '',
      analyticTableData: [],
      loading: true,
      chartTemp: {},
      ctxTemp: {},
      chartCO: {},
      ctxCO: {},
      chartNoiseSound: {},
      ctxNoiseSound: {},
      alreadyRendered: false,
      environmentData: [],
      environmentDate: '',
      dateFillter: new Date(),
      language: localStorage.getItem('lang') || 'fr',
      tempChartData: [],
      coChartData: [],
      noiseSoundChartData: [],
      chartTimeArray: [
        '00:30 AM',
        '00:35 AM',
        '00:40 AM',
        '00:45 AM',
        '00:50 AM',
        '00:55 AM',
        '01:00 AM',
        '01:05 AM',
        '01:10 AM',
        '01:15 AM',
        '01:20 AM',
        '01:25 AM',
        '01:30 AM',
        '01:35 AM',
        '01:40 AM',
        '01:45 AM',
        '01:50 AM',
        '01:55 AM',
        '02:00 AM',
        '02:05 AM',
        '02:10 AM',
        '02:15 AM',
        '02:20 AM',
        '02:25 AM',
        '02:30 AM',
        '02:35 AM',
        '02:40 AM',
        '02:45 AM',
        '02:50 AM',
        '02:55 AM',
        '03:00 AM',
        '03:05 AM',
        '03:10 AM',
        '03:15 AM',
        '03:20 AM',
        '03:25 AM',
        '03:30 AM',
        '03:35 AM',
        '03:40 AM',
        '03:45 AM',
        '03:50 AM',
        '03:55 AM',
        '04:00 AM',
        '04:05 AM',
        '04:10 AM',
        '04:15 AM',
        '04:20 AM',
        '04:25 AM',
        '04:30 AM',
        '04:35 AM',
        '04:40 AM',
        '04:45 AM',
        '04:50 AM',
        '04:55 AM',
        '05:00 AM',
        '05:05 AM',
        '05:10 AM',
        '05:15 AM',
        '05:20 AM',
        '05:25 AM',
        '05:30 AM',
        '05:35 AM',
        '05:40 AM',
        '05:45 AM',
        '05:50 AM',
        '05:55 AM',
        '06:00 AM',
        '06:05 AM',
        '06:10 AM',
        '06:15 AM',
        '06:20 AM',
        '06:25 AM',
        '06:30 AM',
        '06:35 AM',
        '06:40 AM',
        '06:45 AM',
        '06:50 AM',
        '06:55 AM',
        '07:00 AM',
        '07:05 AM',
        '07:10 AM',
        '07:15 AM',
        '07:20 AM',
        '07:25 AM',
        '07:30 AM',
        '07:35 AM',
        '07:40 AM',
        '07:45 AM',
        '07:50 AM',
        '07:55 AM',
        '08:00 AM',
        '08:05 AM',
        '08:10 AM',
        '08:15 AM',
        '08:20 AM',
        '08:25 AM',
        '08:30 AM',
        '08:35 AM',
        '08:40 AM',
        '08:45 AM',
        '08:50 AM',
        '08:55 AM',
        '09:00 AM',
        '09:05 AM',
        '09:10 AM',
        '09:15 AM',
        '09:20 AM',
        '09:25 AM',
        '09:30 AM',
        '09:35 AM',
        '09:40 AM',
        '09:45 AM',
        '09:50 AM',
        '09:55 AM',
        '10:00 AM',
        '10:05 AM',
        '10:10 AM',
        '10:15 AM',
        '10:20 AM',
        '10:25 AM',
        '10:30 AM',
        '10:35 AM',
        '10:40 AM',
        '10:45 AM',
        '10:50 AM',
        '10:55 AM',
        '11:00 AM',
        '11:05 AM',
        '11:10 AM',
        '11:15 AM',
        '11:20 AM',
        '11:25 AM',
        '11:30 AM',
        '11:35 AM',
        '11:40 AM',
        '11:45 AM',
        '11:50 AM',
        '11:55 AM',
        '12:00 PM',
        '12:05 PM',
        '12:10 PM',
        '12:15 PM',
        '12:20 PM',
        '12:25 PM',
        '12:30 PM',
        '12:35 PM',
        '12:40 PM',
        '12:45 PM',
        '12:50 PM',
        '12:55 PM',
        '13:00 PM',
        '13:05 PM',
        '13:10 PM',
        '13:15 PM',
        '13:20 PM',
        '13:25 PM',
        '13:30 PM',
        '13:35 PM',
        '13:40 PM',
        '13:45 PM',
        '13:50 PM',
        '13:55 PM',
        '14:00 PM',
        '14:05 PM',
        '14:10 PM',
        '14:15 PM',
        '14:20 PM',
        '14:25 PM',
        '14:30 PM',
        '14:35 PM',
        '14:40 PM',
        '14:45 PM',
        '14:50 PM',
        '14:55 PM',
        '15:00 PM',
        '15:05 PM',
        '15:10 PM',
        '15:15 PM',
        '15:20 PM',
        '15:25 PM',
        '15:30 PM',
        '15:35 PM',
        '15:40 PM',
        '15:45 PM',
        '15:50 PM',
        '15:55 PM',
        '16:00 PM',
        '16:05 PM',
        '16:10 PM',
        '16:15 PM',
        '16:20 PM',
        '16:25 PM',
        '16:30 PM',
        '16:35 PM',
        '16:40 PM',
        '16:45 PM',
        '16:50 PM',
        '16:55 PM',
        '17:00 PM',
        '17:05 PM',
        '17:10 PM',
        '17:15 PM',
        '17:20 PM',
        '17:25 PM',
        '17:30 PM',
        '17:35 PM',
        '17:40 PM',
        '17:45 PM',
        '17:50 PM',
        '17:55 PM',
        '18:00 PM',
        '18:05 PM',
        '18:10 PM',
        '18:15 PM',
        '18:20 PM',
        '18:25 PM',
        '18:30 PM',
        '18:35 PM',
        '18:40 PM',
        '18:45 PM',
        '18:50 PM',
        '18:55 PM',
        '19:00 PM',
        '19:05 PM',
        '19:10 PM',
        '19:15 PM',
        '19:20 PM',
        '19:25 PM',
        '19:30 PM',
        '19:35 PM',
        '19:40 PM',
        '19:45 PM',
        '19:50 PM',
        '19:55 PM',
        '20:00 PM',
        '20:05 PM',
        '20:10 PM',
        '20:15 PM',
        '20:20 PM',
        '20:25 PM',
        '20:30 PM',
        '20:35 PM',
        '20:40 PM',
        '20:45 PM',
        '20:50 PM',
        '20:55 PM',
        '21:00 PM',
        '21:05 PM',
        '21:10 PM',
        '21:15 PM',
        '21:20 PM',
        '21:25 PM',
        '21:30 PM',
        '21:35 PM',
        '21:40 PM',
        '21:45 PM',
        '21:50 PM',
        '21:55 PM',
        '22:00 PM',
        '22:05 PM',
        '22:10 PM',
        '22:15 PM',
        '22:20 PM',
        '22:25 PM',
        '22:30 PM',
        '22:35 PM',
        '22:40 PM',
        '22:45 PM',
        '22:50 PM',
        '22:55 PM',
        '23:00 PM',
        '23:05 PM',
        '23:10 PM',
        '23:15 PM',
        '23:20 PM',
        '23:25 PM',
        '23:30 PM',
        '23:35 PM',
        '23:40 PM',
        '23:45 PM',
        '23:50 PM',
        '23:55 PM',
        '00:00 AM',
      ],
      environmentNotConfigured: true,
      netatmoConfiguredForRental: false,
      userHaveConfiguredNetatmo: false,
      chartsOptions: {
        hover: {
          mode: 'nearest',
          intersect: true,
        },
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: false,
              fontColor: '#a2acb4',
              padding: 10,
              max: 100,
            },
            scaleLabel: {
              display: true,
            },
            stacked: true,
          }],
          xAxes: [{
            ticks: {
              fontColor: '#a2acb4',
            },
            scaleLabel: {
              display: true,
            },
          }],
        },
        tooltips: {
          position: 'nearest',
          mode: 'point',
          intersect: false,
          yPadding: 15,
          xPadding: 15,
          caretSize: 8,
          backgroundColor: '#fff',
          titleFontColor: '#000000',
          bodyFontColor: '#000000',
          borderColor: 'rgba(0,0,0,1)',
          borderWidth: 4,
        },
        legend: {
          display: false,
        },
      },
      accessToTabsStatus: {
        general: false,
        rentals: false,
        reviews: false,
        environment: false,
        market: false,
        analyses: false,
      },
      groups: [],
      others: [],
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading: require('components/loading/loading.vue'),
    DatePicker,
    VExportAnalysis: require('components/export-analysis/export-analysis.vue'),
    VGenerateAnalyses: require('components/generate-analyses/index.vue'),
    VGenerateConcierge: require('components/generate-concierge/Concierge'),
    VGenerateExtractor: require('components/generate-extractor/index.vue'),
    VGenerateCityTaxes: require('components/city-taxes/CityTaxesModal.vue'),
  },
  mixins: [mixin],
  methods: {
    new_rental() {
      Vue.router.push({
        name: 'rentals.create',
      });
    },
    closeModal(selector) {
      $(selector).removeClass('show');
      $('.panel-overlay').fadeOut();
      $('body').removeClass('modal-open');
      $('div.modal-backdrop.fade.show').remove();
    },
    async get_rental_environment_data(id) {
      const vm = this;
      let url = '';
      vm.loading = true;

      if (id === 'all') {
        vm.selectedRental = vm.rentals[0].id;
        id = vm.selectedRental;
      }

      Vue.router.push({
        name: 'analytics.environment.tab',
        params: {
          id,
        },
      });
      url = `/get-data-for-environment/${id}?`;
      if (vm.environmentDate) {
        const da = moment(vm.environmentDate).format('DD-MM-YYYY');
        url += `&environmentDate=${da}`;
      }

      await analyticsService.getEnvironmentTab(url, this);
    },
    change_tab(tab) {
      const vm = this;
      const params = {
        id: vm.selectedRental,
      };
      if (tab === 'market') {
        params.start = moment().format('Y-MM-DD');
        params.end = moment().add(30, 'days').format('Y-MM-DD');
      }
      Vue.router.push({
        name: `analytics.${tab}.tab`,
        params: tab !== 'general' && params,
      });
    },
    renderTempCharts(data) {
      const vm = this;
      vm.ctxTemp = document.getElementById('temperature-chart').getContext('2d');

      vm.chartsOptions.scales.yAxes[0].ticks.max = 45;
      vm.chartsOptions.scales.yAxes[0].ticks.min = 10;

      vm.chartTemp = new Chart(vm.ctxTemp, {
        type: 'line',
        data: vm.getDoughnutAndGradient(vm.ctxTemp, data),
        options: vm.chartsOptions,
      });
    },
    renderCOCharts(data) {
      const vm = this;
      vm.ctxCO = document.getElementById('co-chart').getContext('2d');

      delete vm.chartsOptions.scales.yAxes[0].ticks.max;
      vm.chartsOptions.scales.yAxes[0].ticks.min = 100;

      vm.chartCO = new Chart(vm.ctxCO, {
        type: 'line',
        data: vm.getDoughnutAndGradient(vm.ctxCO, data),
        options: vm.chartsOptions,
      });
    },
    renderNoiseSoundCharts(data) {
      const vm = this;
      vm.ctxNoiseSound = document.getElementById('noise-sound-chart').getContext('2d');

      vm.chartsOptions.scales.yAxes[0].ticks.max = 90;
      vm.chartsOptions.scales.yAxes[0].ticks.min = 30;

      vm.chartNoiseSound = new Chart(vm.ctxNoiseSound, {
        type: 'line',
        data: vm.getDoughnutAndGradient(vm.ctxNoiseSound, data),
        options: vm.chartsOptions,
      });
    },
    getDoughnutAndGradient(ctx, data) {
      const vm = this;
      const gradientColorOrange = ctx.createLinearGradient(0, 0, 0, 600);
      gradientColorOrange.addColorStop(0, '#D7092E3b');
      gradientColorOrange.addColorStop(0.5, '#ffffff00');
      gradientColorOrange.addColorStop(1, '#ffffff00');

      const doughnutData = {
        labels: vm.chartTimeArray,
        datasets: [{
          data,
          backgroundColor: gradientColorOrange,
          borderColor: '#D7092E',
          pointBorderColor: '#ffffff',
          pointBorderWidth: 2,
          lineTension: 0,
          pointBackgroundColor: '#D7092E',
        }],
      };
      return doughnutData;
    },
    updateCharts(chart, ctx, data) {
      const vm = this;
      const doughnutData = vm.getDoughnutAndGradient(ctx, data);
      chart.data.labels = doughnutData.labels;
      chart.data.datasets = doughnutData.datasets;
      chart.update();
    },
    generateDataForEnvironmentCharts(data) {
      const vm = this;
      vm.tempChartData = [];
      vm.coChartData = [];
      vm.noiseSoundChartData = [];
      for (const environment in data) {
        const attr = data[environment];
        vm.tempChartData.push(attr[0]);
        vm.coChartData.push(attr[1]);
        vm.noiseSoundChartData.push(attr[2]);
      }
    },
    changeDay(step = 'prev') {
      const today = moment();
      let newDate = '';
      if (step === 'prev') {
        newDate = moment(this.environmentDate).subtract(1, 'days');
      } else {
        newDate = moment(this.environmentDate).add(1, 'days');
      }
      const newDateWithFormat = newDate.format('YYYY-MM-DD');
      if (today.diff(newDate) >= 0) {
        this.environmentDate = newDateWithFormat;
        this.get_rental_environment_data(this.selectedRental);
      }
      return false;
    },
    configureRental() {
      Vue.router.push({
        name: 'rentals.detail',
        params: { id: this.selectedRental, tab: 'services' },
      });
    },
    configureNetatmo() {
      Vue.router.push({
        name: 'account.settings.tab',
        params: { tab: 'services' },
      });
    },
    openModal(selector) {
      $(selector).addClass('show');
      $('body').addClass('modal-open');
      $('body').append('<div class="modal-backdrop fade show"></div>');
      $('.modal-content').css({ display: 'block' });
    },
    getOtherRentals() { // get rentals which are not in any groups
      const vm = this;
      const removed = [];
      const isGroups = vm.groups.length > 0;
      // if there are not groups then all rentals will be in 'others' group
      if (!isGroups) {
        const group = {
          id: 0,
          name: 'others',
          rentals: vm.others,
        };
        Vue.set(vm.groups, vm.groups.length, group);
      }
      for (let i = 0; i < vm.rentals.length; i++) {
        const rental = vm.rentals[i];
        for (let j = 0; j < vm.groups.length; j++) {
          const group = vm.groups[j];
          const check = group.rentals.filter(r => r.id === rental.id);
          if (check.length > 0) {
            const check1 = vm.others.filter(r => r.id === rental.id);
            if (check1.length > 0) {
              const index = vm.others.indexOf(rental);
              vm.others.splice(index, 1);
              break;
            }
            removed.push(rental);
          } else {
            const check2 = vm.others.filter(r => r.id === rental.id);
            if (check2.length === 0 && !removed.includes(rental)) {
              vm.others.push(rental);
            }
          }
        }
      }
      // add group with rentals which are not in any groups
      if (isGroups) {
        const group = {
          id: 0,
          name: 'others',
          rentals: vm.others,
        };
        Vue.set(vm.groups, vm.groups.length, group);
      }
      return vm.others;
    },
  },
  async mounted() {
    const vm = this;
    moment.locale('fr', {
      months: this.$t('months'),
      weekdaysShort: this.$t('medWeekDays'),
      monthsShort: this.$t('shortMonths'),
    });
    vm.environmentDate = moment().format('YYYY-MM-DD');
    vm.month = moment().format('M');
    vm.year = moment().format('YYYY');
    vm.loading = true;

    await accountService.fetchUserAccount(this, true);
    await this.checkAccessToTabs(this);
    await rentalService.getGroups(this, false, true);
    await rentalService.getAll(this, true);
    if (vm.$route.params.id) {
      vm.selectedRental = vm.$route.params.id;
    } else {
      vm.selectedRental = vm.rentals.length > 0 ? vm.rentals[0].id : '';
      Vue.router.push({
        name: 'analytics.environment.tab',
        params: {
          id: vm.selectedRental,
        },
      });
    }
    await vm.get_rental_environment_data(vm.selectedRental);
    this.getOtherRentals();
  },
  watch: {
    'account.lang': function () {
      this.language = localStorage.getItem('lang') || 'fr';
      moment.locale('fr', {
        months: this.$t('months'),
        weekdaysShort: this.$t('medWeekDays'),
        monthsShort: this.$t('shortMonths'),
      });
    },
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/analytics/environment/environment.js